import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material'
import { isEqual } from 'lodash'
import dayjs from 'dayjs'
import { TextField } from 'formik-material-ui'
import { Field, Form, Formik } from 'formik'
import { memo, useContext, useMemo } from 'react'
import { metodoPrograma } from '../../../components/api'
import CloseIcon from '@mui/icons-material/Close'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import { GlobalContext } from '../../../App'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import DateTimeField from '../../../components/DateTimeField/DateTimeField'

const retornaDados = (u = []) => ({
  idConta: u?.[0] || undefined,
  idCategoriaConta: u?.[1]?.[0]?.[0] || null,
  acCategoriaConta: u?.[1] || null,
  idFormaPagamento: u?.[2]?.[0]?.[0] || null,
  acFormaPagamento: u?.[2] || null,
  idEmpresa: u?.[3]?.[0]?.[0] || null,
  acEmpresa: u?.[3] || null,
  idPaciente: u?.[4]?.[0]?.[0] || null,
  acPaciente: u?.[4] || null,
  nrDocumento: u?.[5] || '',
  dsConta: u?.[7] || '',
  dsObservacao: u?.[8] || '',
  dtVencimento: u?.[11] || '',
  dtEmissao: u?.[12] || '',
  dtRecebimento: u?.[13] || '',
  vlConta: u?.[15] || '',
  vlQuitacao: u?.[17] || undefined,
  idPlanoConta: u?.[19]?.[0]?.[0] || null,
  acPlanoConta: u?.[19] || null,
  idCentroCusto: u?.[20]?.[0]?.[0] || null,
  acCentroCusto: u?.[20] || null,
  idContaBancaria: u?.[21]?.[0]?.[0] || null,
  acContaBancaria: u?.[21] || null,
})

export const ModalContaAReceber = ({
  show,
  setModal,
  handleClose,
  dados,
  setRefresh,
}) => {
  const { localAtendimento } = useContext(GlobalContext)

  const formato = 'YYYY-MM-DD HH:mm:ss'

  const searchPrm = useMemo(
    () => ({
      idEmpresa: dados?.[3]?.[0]?.[0],
      idLocalAtendimento: localAtendimento[0],
    }),
    [dados, localAtendimento],
  )

  const salva = async (values) => {
    const dataEmissao = dayjs(values.dtEmissao)
    if (!dataEmissao.isValid()) {
      values.dtEmissao = undefined
    } else {
      values.dtEmissao = dataEmissao.format(formato)
    }

    const dataVencimento = dayjs(values.dtVencimento)
    if (!dataVencimento.isValid()) {
      values.dtVencimento = undefined
    } else {
      values.dtVencimento = dataVencimento.format(formato)
    }
    values.vlConta = values.vlConta ? Number(values.vlConta) : 0
    values.idCategoriaConta = values.acCategoriaConta?.[0][0] || null
    values.idCentroCusto = values.acCentroCusto?.[0][0] || null
    values.idPlanoConta = values.acPlanoConta?.[0][0] || null
    values.idContaBancaria = values.acContaBancaria?.[0][0] || null
    values.idPaciente = values.acPaciente?.[0][0] || null
    values.idFormaPagamento = values.acFormaPagamento?.[0][0] || null
    const res = await metodoPrograma('salva', values)
    if (res.status) {
      setModal(false)
      setRefresh((prev) => prev + 1)
      return true
    }
  }

  return (
    <Formik
      initialValues={retornaDados(dados)}
      enableReinitialize
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        const resp = await salva(values)
        setSubmitting(false)
        if (resp) resetForm()
      }}
    >
      {({ isSubmitting, submitForm, values, setFieldValue }) => (
        <Form>
          <Dialog
            open={show}
            aria-label="close"
            keepMounted
            handleClose={handleClose}
            fullWidth={true}
            maxWidth={'lg'}
            md={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>Conta a Receber</DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    InputLabelProps={{ shrink: true }}
                    name="nrDocumento"
                    label="Nro Documento"
                    disabled={values.dtRecebimento}
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    component={TextField}
                    InputLabelProps={{ shrink: true }}
                    name="dsConta"
                    label="Nome da Conta"
                    disabled={values.dtRecebimento}
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={3}>
                  <CurrencyField
                    InputLabelProps={{ shrink: true }}
                    name="vlConta"
                    label="Valor"
                    fullWidth
                    disabled={values.dtRecebimento}
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values?.vlConta}
                    onChange={(v) => {
                      setFieldValue('vlConta', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Empresa"
                    metodo="buscaEmpresa"
                    value={values.acEmpresa}
                    disabled={values.dtRecebimento}
                    size="small"
                    onChange={(_, v) => {
                      setFieldValue('idEmpresa', v?.[0]?.[0])
                      setFieldValue('acEmpresa', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Paciente"
                    metodo="buscaPaciente"
                    value={values.acPaciente}
                    disabled={values.dtRecebimento}
                    searchParams={searchPrm}
                    onChange={(_, v) => {
                      setFieldValue('idPaciente', v?.[0]?.[0])
                      setFieldValue('acPaciente', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Plano de Conta"
                    metodo="buscaPlanoConta"
                    value={values.acPlanoConta}
                    searchParams={{ idEmpresa: values?.idEmpresa || undefined }}
                    onChange={(_, v) => {
                      setFieldValue('idPlanoConta', v?.[0]?.[0])
                      setFieldValue('acPlanoConta', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Centro de Custo"
                    metodo="buscaCentroCusto"
                    value={values.acCentroCusto}
                    searchParams={{ idEmpresa: values?.idEmpresa || undefined }}
                    onChange={(_, v) => {
                      setFieldValue('idCentroCusto', v?.[0]?.[0])
                      setFieldValue('acCentroCusto', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Conta Banária"
                    metodo="buscaContaBancaria"
                    value={values.acContaBancaria}
                    searchParams={{ idEmpresa: values?.idEmpresa || undefined }}
                    disabled={values.dtRecebimento}
                    onChange={(_, v) => {
                      setFieldValue('idContaBancaria', v?.[0]?.[0])
                      setFieldValue('acContaBancaria', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Forma de Recebimento"
                    metodo="buscaFormaPagamento"
                    value={values.acFormaPagamento}
                    disabled={values.dtRecebimento}
                    onChange={(_, v) => {
                      setFieldValue('idFormaPagamento', v?.[0]?.[0])
                      setFieldValue('acFormaPagamento', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Categoria"
                    metodo="buscaCategoriaConta"
                    value={values.acCategoriaConta}
                    onChange={(_, v) => {
                      setFieldValue('idCategoriaConta', v?.[0]?.[0])
                      setFieldValue('acCategoriaConta', v)
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <DateTimeField
                    name="dtEmissao"
                    label="Emissão"
                    fullWidth
                    disabled={values.dtRecebimento}
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values?.dtEmissao || null}
                    onChange={(v) => setFieldValue('dtEmissao', v)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <DateTimeField
                    name="dtVencimento"
                    label="Vencimento"
                    fullWidth
                    disabled={values.dtRecebimento}
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values?.dtVencimento || null}
                    onChange={(v) => setFieldValue('dtVencimento', v)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    component={TextField}
                    InputLabelProps={{ shrink: true }}
                    name="dsObservacao"
                    label="Observações"
                    disabled={values.dtRecebimento}
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={3}>
                  <DateTimeField
                    name="dtRecebimento"
                    label="Data de Recebimento"
                    fullWidth
                    disabled
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={values?.dtRecebimento || null}
                    onChange={(v) => setFieldValue('dtRecebimento', v)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoComplete
                    InputLabelProps={{ shrink: true }}
                    label="Forma de Recebimento"
                    metodo="buscaFormaPagamento"
                    disabled
                    value={values.acFormaPagamento}
                    onChange={(_, v) => {
                      setFieldValue('idFormaPagamento', v?.[0]?.[0])
                      setFieldValue('acFormaPagamento', v)
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <CurrencyField
                    name="vlQuitacao"
                    label="Valor Recebido"
                    fullWidth
                    disabled
                    margin="dense"
                    variant="outlined"
                    size="small"
                    value={dados?.vlQuitacao}
                    onChange={(v) => {
                      setFieldValue('vlQuitacao', v)
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
            </DialogActions>
          </Dialog>
        </Form>
      )}
    </Formik>
  )
}

export default memo(ModalContaAReceber, isEqual)
